// Shared helpers for the Admin ↔ Employee message-exchange notifications:
// a synthesized "water drop" chime (no audio file needed) + an optional
// desktop Notification popup for admins who opt in.

let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  }
  return audioCtx;
}

// Browsers block audio until a user gesture happens — unlock as soon as
// the user clicks/types/taps anywhere on the page, so the very first real
// notification sound isn't silently swallowed.
if (typeof window !== "undefined") {
  const unlock = () => { try { getCtx()?.resume(); } catch { /* ignore */ } };
  ["click", "keydown", "touchstart"].forEach(evt => window.addEventListener(evt, unlock, { once: true, passive: true }));
}

/** A short, synthesized water-droplet "plink" — a quick pitch-down blip. */
export function playWaterDropSound() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(1200, now);
    osc.frequency.exponentialRampToValueAtTime(280, now + 0.18);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.35, now + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.4);
  } catch { /* audio unsupported/blocked — fail silently, toast still shows */ }
}

/** Native OS-level notification popup — works even if the tab is in the
 * background (not if the browser itself is fully closed). Opt-in only. */
export function showDesktopNotification(title, body) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  try { new Notification(title, { body, icon: "/favicon.ico" }); } catch { /* ignore */ }
}

export const ADMIN_PUSH_PREF_KEY = "counseltaria_admin_push_enabled";

export function isAdminPushEnabled() {
  return typeof localStorage !== "undefined" && localStorage.getItem(ADMIN_PUSH_PREF_KEY) === "1";
}
